import { ComponentProps } from 'react'
import { makeStyles } from '@mui/styles'

import { joinStyles } from '@/utils/app/theme'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
})

type FormProperties = ComponentProps<'form'>

export const Form = ({
    className,
    ...properties
}: Readonly<FormProperties>) => {
    const classes = useStyles()

    return (
        <form
            className={joinStyles(classes.root, className)}
            {...properties}
        />
    )
}
